<template>
  <CHeader data-aos-easing="linear" data-aos-duration="1500" id="el" class="navbars">
      <CHeaderBrand class="mx-auto" to="/">
          <img src="../assets/img/Logo(1).png" height="32" class="m-2" alt="Interviewrr.ai company logo" /> <span class="custom-20px-500">Interviewrr</span>
      </CHeaderBrand>
  
      <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
          <template #toggler-content>
                                <CIcon name="cil-justify-center" />
</template>
     
      <CDropdownItem href="homepage"
        >START INTERVIEW</CDropdownItem
      >

     
      <CDropdown style="margin-left:7px">
<template #toggler-content>
   PLAN
</template>
      <CDropdownItem
        to="PlanIndividual"
        target="_blank"
        >CANDIDATE</CDropdownItem
      >
      <CDropdownItem
        to="PlanCompany"
        target="_blank"
        >COMPANY</CDropdownItem
      >
     
    </CDropdown>

    <CDropdownItem href="Profile"
        >MY PROFILE</CDropdownItem
      >

      <CDropdownItem @click="SignOut()"
        >LOG OUT</CDropdownItem
      >

      

    
<!-- 
      <CDropdown style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            ">
<template #toggler-content>
    <label style="
                              color: #171717;font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px;  margin-top:9px;"> <img :src="filepath" height="30px" style="border-radius: 50%; object-fit: cover;" alt="User of Interviewrr.ai"/></label>
</template>
        <CDropdownItem
          to="Profile"
          >My Profile</CDropdownItem
        >
        <CDropdownItem
          @click="SignOut()"
          >Log Out</CDropdownItem
        >
       
      </CDropdown>
       -->

       
      

      </CDropdown>

      
  
      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
            color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="Homepage"
          >
            Start Interview
          </CHeaderNavLink>
        </CHeaderNavItem>

    

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
          style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="/Profile"
          >
         My Profile
          </CHeaderNavLink>
        </CHeaderNavItem>


      

  <CHeaderNavItem style="margin-top:-9px">
  <a
  @click="SignOut"
    style="
      color: #171717;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      text-decoration: none;
    "
  >
    Log Out
  </a>
</CHeaderNavItem>

   
      
      

       

     

      
      


      
        

       
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
          style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="/ContactUs"
          >
         
          </CHeaderNavLink>
        </CHeaderNavItem>


        <!-- <CDropdown style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            ">
<template #toggler-content>
    <label style="
                              color: #171717;font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px;  margin-top:9px;"> <img :src="filepath" height="30px" alt="User of Interviewrr.ai"/></label>
</template>
        <CDropdownItem
          to="Profile"
          >My Profile</CDropdownItem
        >
        <CDropdownItem
          @click="SignOut()"
          >Log Out</CDropdownItem
        >
       
      </CDropdown>
          -->

     


    

      

     

  
      </CHeaderNav>
    </CHeader>
  </template>
      
<script>
export default {
    name: "TheHeader",
    data() {
        return {
            Name: "",
            filepath: "",
        };
    },
    async mounted() {
        this.GetInfoUser();
    },
    methods: {

        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Name = this.user.name;
                    this.filepath = this.user.filePath;
                } else {
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        GoToLogin() {
            this.$router.push("/LogIn");
        },
        SignOut: function() {
            return this.$API
                .get(this.$SignOut, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                      this.user = "";
                      this.Name = "",
                        this.$router.push("/");
                    }
                });
        },
    },
};
</script>
      

<style scoped>

</style>
  
  
  